import { footerColumns, heroTags } from "@/mocks/home";

export default function SiteFooter() {
  return (
    <footer className="border-t border-background-300 bg-secondary-100">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-6 md:py-20 lg:px-10">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-12 lg:gap-8">
          <div className="lg:col-span-4">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-foreground-950 text-background-50">
                <i className="ri-flashlight-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">
                黑网爆料
              </span>
            </a>
            <p className="mt-5 max-w-sm text-sm leading-7 text-foreground-600">
              黑网爆料专注深挖黑灰产与黑色产业链，持续曝光暗黑交易、地下市场及黑市信息，用可核验的材料替读者挡下一次风险。
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {heroTags.slice(0, 4).map((tag) => (
                <span
                  key={tag}
                  className="rounded-full border border-secondary-300 bg-background-50 px-3 py-1 text-xs text-secondary-800"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          {footerColumns.map((column) => (
            <div key={column.title} className="lg:col-span-2">
              <h3 className="font-heading text-sm font-bold tracking-wide text-foreground-950">
                {column.title}
              </h3>
              <ul className="mt-5 space-y-3">
                {column.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#topics"
                      className="whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="lg:col-span-2">
            <h3 className="font-heading text-sm font-bold tracking-wide text-foreground-950">
              线索投递
            </h3>
            <p className="mt-5 text-sm leading-7 text-foreground-600">
              线报一经核验即进入合集，来源严格保密。
            </p>
            <a
              href="#desk"
              className="mt-4 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-send-plane-line"></i>
              安全投递
            </a>
          </div>
        </div>

        <div className="mt-12 border-t border-secondary-300 pt-6">
          <p className="text-xs leading-6 text-foreground-500">
            本站内容为公开线报与多方核验材料的整理展示，仅用于风险提示与行业观察，不构成任何投资、交易或法律建议。涉及存疑信息均已标注，请读者自行判断。
          </p>
          <div className="mt-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <p className="text-xs text-foreground-500">
              © 2026 黑网爆料 编辑部 · 所有材料均经脱敏处理
            </p>
            <div className="flex items-center gap-4 text-foreground-500">
              <a href="#desk" rel="nofollow" className="transition-colors hover:text-primary-600">
                <i className="ri-mail-line"></i>
              </a>
              <a href="#desk" rel="nofollow" className="transition-colors hover:text-primary-600">
                <i className="ri-shield-keyhole-line"></i>
              </a>
              <a href="#desk" rel="nofollow" className="transition-colors hover:text-primary-600">
                <i className="ri-rss-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}